var windowHeight = function windowHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};

export default windowHeight;